'use strict';

module.exports = function () {
  var defaults = require('../config/defaults')();
  return this.initOptions(defaults, this.globalOptions, this.options);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/opts.js